module.exports = __webpack_public_path__ + "img/kitchen-device.4119fa7d.png";